   // Tab switching functionality
   document.addEventListener('DOMContentLoaded', function() {
     document.querySelectorAll('.tab-header').forEach(tab => {
       tab.addEventListener('click', function() {
         const tabId = this.dataset.tab;
         
         // Update active tab header
         document.querySelectorAll('.tab-header').forEach(item => {
           item.classList.remove('active');
         });
         this.classList.add('active');
         
         // Show corresponding content
         document.querySelectorAll('.tab-content').forEach(content => {
           content.classList.remove('active');
         });
         document.getElementById(`${tabId}Tab`).classList.add('active');
       });
     });
   });

   // 其他从原文件提取的JS逻辑（如规格表交互、视频加载等）